import { __exports as EAN2 } from "./index195.js";
import { __require as requireConstants } from "./index190.js";
import { __require as requireEncoder } from "./index194.js";
import { __require as requireBarcode } from "./index158.js";
var hasRequiredEAN2;
function requireEAN2() {
  if (hasRequiredEAN2) return EAN2;
  hasRequiredEAN2 = 1;
  Object.defineProperty(EAN2, "__esModule", {
    value: true
  });
  var _createClass = /* @__PURE__ */ (function() {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }
    return function(Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  })();
  var _constants = requireConstants();
  var _encoder = requireEncoder();
  var _encoder2 = _interopRequireDefault(_encoder);
  var _Barcode2 = requireBarcode();
  var _Barcode3 = _interopRequireDefault(_Barcode2);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }
  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }
  var EAN2$1 = (function(_Barcode) {
    _inherits(EAN22, _Barcode);
    function EAN22(data, options) {
      _classCallCheck(this, EAN22);
      return _possibleConstructorReturn(this, (EAN22.__proto__ || Object.getPrototypeOf(EAN22)).call(this, data, options));
    }
    _createClass(EAN22, [{
      key: "valid",
      value: function valid() {
        return this.data.search(/^[0-9]{2}$/) !== -1;
      }
    }, {
      key: "encode",
      value: function encode() {
        var structure = _constants.EAN2_STRUCTURE[parseInt(this.data) % 4];
        return {
          // Start bits + Encode the two digits with 01 in between
          data: "1011" + (0, _encoder2.default)(this.data, structure, "01"),
          text: this.text
        };
      }
    }]);
    return EAN22;
  })(_Barcode3.default);
  EAN2.default = EAN2$1;
  return EAN2;
}
export {
  requireEAN2 as __require
};
//# sourceMappingURL=index168.js.map
